function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import Common from './includes/Common';
import { notification, Skeleton, Result, Button } from "antd";
import AddOrganization from './forms/AddOrganization';
import AddEvent from './forms/AddEvent';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var NewEventBox = function NewEventBox() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    organization = _useState4[0],
    setOrganization = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showEventForm = _useState6[0],
    setShowEventForm = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    showOrgForm = _useState8[0],
    setShowOrgForm = _useState8[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getuserorganization/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        if (response.data.organization != null) {
          setOrganization(response.data.organization);
          setShowEventForm(true);
          setShowOrgForm(false);
        } else {
          setShowOrgForm(true);
        }
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue"
      });
      setShowOrgForm(false);
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), isDataLoading == false && /*#__PURE__*/_jsxs(_Fragment, {
      children: [organization == null && showOrgForm == true && /*#__PURE__*/_jsx(AddOrganization, {
        handler: function handler(o) {
          setOrganization(o);
          setShowOrgForm(false);
          setShowEventForm(true);
        }
      }), organization != null && showEventForm == true && /*#__PURE__*/_jsx(AddEvent, {
        organization: organization,
        handler: function handler() {
          setShowEventForm(false);
        }
      }), organization != null && showEventForm == false && showOrgForm == false && /*#__PURE__*/_jsx(Result, {
        status: "success",
        title: "Votre \xE9v\xE8nement \xE0 \xE9t\xE9 annonc\xE9 avec succ\xE8s !",
        subTitle: "Notre \xE9quipe \xE0 bien r\xE9\xE7u votre \xE9v\xE8nement et fera les validations dans les meilleurs d\xE9lais afin de le proposer au publique",
        extra: [/*#__PURE__*/_jsx(Button, {
          type: "primary",
          href: "/#/home",
          children: /*#__PURE__*/_jsx("b", {
            children: "ALLER A L'ACCUEIL"
          })
        }, "home"), /*#__PURE__*/_jsx(Button, {
          href: "/#/home/account/events",
          children: /*#__PURE__*/_jsx("b", {
            children: "VOIR VOTRE EVENEMENT"
          })
        }, "account")]
      })]
    })]
  });
};
export default NewEventBox;